import { EpLogger } from '../../util/ep-logger';
import { autoInjectable, singleton } from 'tsyringe';
import {  ApiException, GeneratePlacementRequest, GeneratePlacementResponse } from '@ads-ep/fetch-api-client';
import { ConfigUtilService } from '../../services/config/config-util.service';
import { RemoteBrandConfigResp } from '../../models/remote-brand-config.resp';

@autoInjectable()
@singleton()
export class EpApi {
  get config(){
    return this.configUtilService.getConfig();
  }
  defaultOptions: RequestInit = {
    headers: {
      'content-type': 'application/json'
    },
    mode: 'cors'
  };

  commonOptions: RequestInit = {
    cache: 'no-store'
  };

  constructor(private logger?: EpLogger,
              private configUtilService?: ConfigUtilService) {}

  async init() {
    let configResp;
    try {
      configResp = await this.getBrandConfig();
    }catch(e){
      this.logger.error('Unable to fetch config', e);
    }

    if(configResp){
      this.configUtilService.loadRemoteConfig(configResp);
    }
  }

  /*
   * Get brand config from AdServer
   * */
  async getBrandConfig(): Promise<RemoteBrandConfigResp> {
    const options = {
      method: 'GET',
    };
    const brandId = this.config.apiKey;
    const reqOptions: RequestInit = {
      ...options
    };
    const response = await this.makeRequest(`/brands/${brandId}/config`, reqOptions);

    return this.handleResponse<RemoteBrandConfigResp>(response);
  }

  async generatePlacements(placementRequest?: GeneratePlacementRequest){
    if(placementRequest) {
      placementRequest.brandId = this.config.apiKey;
    }

    const options = {
      method: 'POST',
      body: JSON.stringify(placementRequest),
    };

    const response = await this.makeRequest<GeneratePlacementRequest>('/generatePlacements', options);
    return this.handleResponse<GeneratePlacementResponse>(response);
  }

  async fetchBrandStyles(){
    const options = {
      method: 'GET',
    };
    const brandId = this.config.apiKey;
    const reqOptions: RequestInit = {
      ...options
    };
    const response = await this.makeRequest(`/brands/${brandId}/style`, reqOptions);

    return this.handleResponse(response);
  }

  async handleResponse<T>(response: Response){
    if (response.ok) {
      const body: T = await response.json();
      return body;
    }else{
      throw new ApiException<string>(response.status, `Unknown API Status Code!\nBody: "${response.body || ''}"`);
    }
  }

  makeRequest = <T>(path: string, options: Partial<RequestInit>) => {
    const reqOptions: RequestInit = {
      ...this.defaultOptions,
      ...options
    };
    const url = `${this.config.apiHost}${path}`;
    return fetch(url, reqOptions);
  }
}
